<template>
  <div class="header-box">
    <div class="header-con">
      <!-- logo -->
      <div class="logo">
        <img src="../../assets/img/header/logo.png" >
        <div class="stockBox">
          <span>股票名称：金现代</span>
          <span>股票代码：300830</span>
        </div>
      </div>
      <!-- 导航 -->
      <div class="navigator" @click="openForm">
        <img src="../../assets/img/phoneHeader/menu.png" >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PhoneHeader",
    props: {
      isPageScroll: {
        type: Boolean,
        default: false,
      },
      router:{
        type:String,
        default:'',
      },
    },
    watch:{
    },
    data() {
      return {
        path: this.$route.path,
      };
    },
    components: {
    },
    methods: {
      // 打开表单
      openForm() {
        const self = this;
        self.$emit('openForm');
      }
    },
    mounted(){
    }
  }
</script>
<style scoped>
  .header-box {position: fixed;width: 100%;height: 53px;;background: #ffffff;z-index: 999; top: 0}
  .header-con {width: 100%;height: 100%;margin: 0 auto;font-weight: 400;padding-left: 20px; padding-right: 20px}
  .header-con .logo {height: 100%;display: flex;align-items:center;color: #2E2E2E;}
  /* logo */
  .logo {float: left;width: 200px;height: 100%;}
  .logo img {height: 29px;margin-right: 10px}
  .logo .stockBox span {display: block;line-height: 17px;font-size: 11px}
  /* 导航 */
  .navigator {float: right;display: flex;align-items: center;height: 53px}
  .navigator img{height: 18px;width: 20px}
</style>



// WEBPACK FOOTER //
// src/components/include/PhoneHeader.vue